import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ConfigProvider } from 'antd';
import Auth from './components/auth/index.tsx';
import Dashboard from './pages/Dashboard/dashboard.tsx';
import 'react-quill/dist/quill.snow.css';
import MobileAuth from './components/auth/mobile/index.tsx';

const theme = createTheme({
  typography: {
    fontFamily: '"Nunito", sans-serif',
    h1: { fontFamily: '"Nunito", sans-serif' },
    h2: { fontFamily: '"Nunito", sans-serif' },
    h3: { fontFamily: '"Nunito", sans-serif' },
    h4: { fontFamily: '"Nunito", sans-serif' },
    h5: { fontFamily: '"Nunito", sans-serif' },
    h6: { fontFamily: '"Nunito", sans-serif' },
    body1: { fontFamily: '"Nunito", sans-serif' },
    body2: { fontFamily: '"Nunito", sans-serif' },
    button: { fontFamily: '"Nunito", sans-serif' },
    caption: { fontFamily: '"Nunito", sans-serif' },
    overline: { fontFamily: '"Nunito", sans-serif' },
  },
  components: {
    MuiTypography: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiButton: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTextField: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiInputBase: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiInputLabel: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiChip: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTab: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiMenuItem: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiSelect: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiCard: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiPaper: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiDialog: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTooltip: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiFormLabel: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiFormControl: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiCheckbox: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiRadio: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiSwitch: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiSlider: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTabs: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiList: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiListItem: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiListItemText: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTable: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTableCell: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTableHead: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiTableBody: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiAlert: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiSnackbar: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiAutocomplete: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiFormControlLabel: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiDivider: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiAvatar: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiBadge: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiBreadcrumbs: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiLink: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiPagination: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiStepper: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
    MuiStepLabel: { styleOverrides: { root: { fontFamily: '"Nunito", sans-serif' } } },
  },
});


const App: React.FC = () => {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConfigProvider
        theme={{
          token: {
            fontFamily: '"Nunito", sans-serif',
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route
            path="/"
            element={window.outerWidth > 600 ? <Auth/> : <MobileAuth/>}
            />
            </Routes>
            <Routes>
            <Route
            path="/dashboard"
            element={<Dashboard/>}
            />
            </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;